import { FilterList } from '@mui/icons-material'
import { Button, ButtonProps } from '@mui/material'
import { t } from 'i18next'

type FilterButtonProps = ButtonProps & {
  selectedFiltersCount?: number
}

const FilterButton = ({ selectedFiltersCount, ...props }: FilterButtonProps) => {
  return (
    <Button variant="contained" startIcon={<FilterList />} color="secondary" size="small" {...props}>
      {`${t('components.notificationSidebar.filter')}${selectedFiltersCount ? ` (${selectedFiltersCount})` : ''}`}
    </Button>
  )
}

export default FilterButton
